import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { useUserData } from "./useUserProfile";

import { getCurrentSyncLogs } from "../api/reports/reports";
import { createErrorMessage } from "../utils/createErrorMessage";

export const useCurrenSyncLogs = () => {
  const { organizationId, tenantId } = useUserData();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["getCurrentSyncLogs", tenantId, organizationId],
    queryFn: async () => {
      try {
        const res = await getCurrentSyncLogs(organizationId, tenantId);
        return res.data;
      } catch (error) {
        toast.error(createErrorMessage(error));
      }
    },
    enabled: !!tenantId,
  });

  return {
    data: data?.data,
    isLoading,
    error,
    refetch,
  };
};
